<template>
  <div class="filters-container">
    <v-card class="mb-5 filter-card" elevation="3">
      <!-- Collapsible Header -->
      <v-card-title class="primary--text d-flex justify-space-between filter-header" @click="isExpanded = !isExpanded">
        <div class="d-flex align-center">
          <v-icon color="primary" left class="mr-2">mdi-filter-variant</v-icon>
          <span class="text-h6">Filtres des offres</span>
        </div>
        <v-btn icon>
          <v-icon color="primary">{{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Collapsible Content -->
      <v-expand-transition>
        <div v-if="isExpanded">
          <v-divider></v-divider>
          <v-col cols="12" class="mt-4">
                <p class="text-subtitle-1 font-weight-medium grey--text text--darken-2 mb-3">
                  <v-icon small class="mr-1">mdi-sort</v-icon>
                  Trier les offres par
                </p>

                <div class="d-flex flex-wrap">
                  <!-- Budget Sort Button Group -->
                  <div class="mr-4 mb-3">
                    <v-btn-toggle v-model="budgetSortOption" background-color="grey lighten-4" dense class="sort-toggle"
                      @change="onBudgetSortChange">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="null" :color="budgetSortOption === null ? 'primary' : ''"
                              :outlined="budgetSortOption === null" small text>
                              <v-icon small>mdi-currency-eur</v-icon>
                              <span class="ml-1">Budget</span>
                            </v-btn>
                          </div>
                        </template>
                        <span>Aucun tri</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="'asc'" :color="budgetSortOption === 'asc' ? 'primary' : ''"
                              :outlined="budgetSortOption === 'asc'" small text>
                              <v-icon small>mdi-sort-ascending</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Trier par budget croissant</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="'desc'" :color="budgetSortOption === 'desc' ? 'primary' : ''"
                              :outlined="budgetSortOption === 'desc'" small text>
                              <v-icon small>mdi-sort-descending</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Trier par budget décroissant</span>
                      </v-tooltip>
                    </v-btn-toggle>
                  </div>

                  <!-- Commission Sort Button Group -->
                  <div class="mb-3">
                    <v-btn-toggle v-model="commissionSortOption" background-color="grey lighten-4" dense
                      class="sort-toggle" @change="onCommissionSortChange">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="null" :color="commissionSortOption === null ? 'primary' : ''"
                              :outlined="commissionSortOption === null" small text>
                              <v-icon small>mdi-cash</v-icon>
                              <span class="ml-1">Commission</span>
                            </v-btn>
                          </div>
                        </template>
                        <span>Aucun tri</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="'asc'" :color="commissionSortOption === 'asc' ? 'primary' : ''"
                              :outlined="commissionSortOption === 'asc'" small text>
                              <v-icon small>mdi-sort-ascending</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Trier par commission croissante</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <v-btn :value="'desc'" :color="commissionSortOption === 'desc' ? 'primary' : ''"
                              :outlined="commissionSortOption === 'desc'" small text>
                              <v-icon small>mdi-sort-descending</v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span>Trier par commission décroissante</span>
                      </v-tooltip>
                    </v-btn-toggle>
                  </div>
                </div>
              </v-col>

          <v-card-text class="pa-4">
            <v-row>
              <!-- Fournisseur Filter -->
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete v-model="selectedSupplier" :items="suppliers" label="Fournisseur" multiple chips
                  small-chips deletable-chips clearable outlined dense hide-details
                  prepend-inner-icon="mdi-lightning-bolt" class="filter-select"></v-autocomplete>
              </v-col>

              <!-- Contract Duration Filter -->
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete v-model="selectedDuration" :items="durations" label="Durée de contrat" multiple chips
                  small-chips deletable-chips clearable outlined dense hide-details
                  prepend-inner-icon="mdi-calendar-range" class="filter-select"></v-autocomplete>
              </v-col>

              <!-- Energy Type Filter -->
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete v-model="selectedType" :items="types" label="Type d'offre" multiple chips small-chips
                  deletable-chips clearable outlined dense hide-details prepend-inner-icon="mdi-tag-outline"
                  class="filter-select"></v-autocomplete>
              </v-col>

              <!-- Sorting Section -->
       
              <!-- Remuneration Type Filter -->
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete v-model="selectedRemuneration" :items="remunerationTypes" label="Type de rémunération"
                  multiple chips small-chips deletable-chips clearable outlined dense hide-details
                  prepend-inner-icon="mdi-cash-multiple" class="filter-select"></v-autocomplete>
              </v-col>

              <!-- Date Range Filters -->
              <v-col cols="12" md="6" lg="4">
                <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="startDate" label="Date de début" prepend-inner-icon="mdi-calendar-start"
                      readonly v-bind="attrs" v-on="on" outlined dense hide-details clearable
                      @click:clear="startDate = null" class="filter-select"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" @input="startDateMenu = false" color="primary"></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="endDate" label="Date de fin" prepend-inner-icon="mdi-calendar-end" readonly
                      v-bind="attrs" v-on="on" outlined dense hide-details clearable @click:clear="endDate = null"
                      class="filter-select"></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" @input="endDateMenu = false" color="primary"></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Green Energy Filter -->
              <v-col cols="12" class="mt-2 mb-0">
                <v-switch v-model="greenEnergyOnly" label="Uniquement les offres d'énergie verte" color="success"
                  hide-details dense inset>
                  <template v-slot:prepend>
                    <v-icon color="success" class="mr-2">mdi-leaf</v-icon>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4 filter-actions">
            <v-spacer></v-spacer>
            <v-btn text color="grey darken-1" @click="resetFilters" class="mr-3">
              <v-icon left small>mdi-refresh</v-icon>
              Réinitialiser
            </v-btn>
            <v-btn color="primary" @click="applyFilters" elevation="1">
              <v-icon left>mdi-check</v-icon>
              Appliquer les filtres
            </v-btn>
          </v-card-actions>
        </div>
      </v-expand-transition>

      <!-- Indicator for active filters when collapsed -->
      <v-card-subtitle v-if="!isExpanded && hasActiveFilters" class="pa-3 active-filters-indicator">
        <div class="d-flex align-center">
          <v-chip color="primary" small class="mr-2" outlined>
            <v-icon left x-small>mdi-filter</v-icon>
            {{ activeFiltersCount }} filtres actifs
          </v-chip>

          <!-- Display Sort Method if Active -->
          <v-chip v-if="budgetSortOption" color="blue-grey" small class="mr-2" outlined>
            <v-icon left x-small>mdi-currency-eur</v-icon>
            Budget {{ budgetSortOption === 'asc' ? '↑' : '↓' }}
          </v-chip>

          <v-chip v-if="commissionSortOption" color="blue-grey" small class="mr-2" outlined>
            <v-icon left x-small>mdi-cash</v-icon>
            Commission {{ commissionSortOption === 'asc' ? '↑' : '↓' }}
          </v-chip>

          <v-btn x-small text color="primary" @click="resetFilters" class="ml-auto">
            <v-icon x-small left>mdi-refresh</v-icon>
            Réinitialiser
          </v-btn>
        </div>
      </v-card-subtitle>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OffersFilter",
  props: {
    offers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isExpanded: false,

      // Supplier filter
      selectedSupplier: [],
      suppliers: [], // Will be populated from data

      // Duration filter
      selectedDuration: [],
      durations: [], // Will be populated from data

      // Energy type filter
      selectedType: [],
      types: [], // Will be populated from data

      // Remuneration type filter
      selectedRemuneration: [],
      remunerationTypes: [
          { text: 'Marge', value: 'Marge' },
          { text: 'Grille', value: 'Grille' }
        ], // Will be populated from data

      // Budget sorting
      budgetSortOption: null,

      // Commission sorting
      commissionSortOption: null,

      // Date filters
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false,

      // Green energy filter
      greenEnergyOnly: false
    };
  },
  computed: {
    hasActiveFilters() {
      return (
        this.selectedSupplier.length > 0 ||
        this.selectedDuration.length > 0 ||
        this.selectedType.length > 0 ||
        this.selectedRemuneration.length > 0 ||
        this.budgetSortOption !== null ||
        this.commissionSortOption !== null ||
        this.startDate !== null ||
        this.endDate !== null ||
        this.greenEnergyOnly === true
      );
    },
    activeFiltersCount() {
      let count = 0;
      if (this.selectedSupplier.length > 0) count++;
      if (this.selectedDuration.length > 0) count++;
      if (this.selectedType.length > 0) count++;
      if (this.selectedRemuneration.length > 0) count++;
      if (this.budgetSortOption !== null) count++;
      if (this.commissionSortOption !== null) count++;
      if (this.startDate !== null) count++;
      if (this.endDate !== null) count++;
      if (this.greenEnergyOnly === true) count++;
      return count;
    }
  },
  watch: {
    offers: {
      immediate: true,
      handler(newOffers) {
        this.extractFilterOptions(newOffers);
      }
    }
  },
  methods: {
    onBudgetSortChange(value) {
      // If budget sort is activated, reset commission sort
      if (value !== null) {
        this.commissionSortOption = null;
      }
    },

    onCommissionSortChange(value) {
      // If commission sort is activated, reset budget sort
      if (value !== null) {
        this.budgetSortOption = null;
      }
    },
    extractFilterOptions(offers) {
      if (!offers || offers.length === 0) return;

      // Extract unique suppliers
      const uniqueSuppliers = [...new Set(offers.flatMap(offer =>
        offer.resultat?.result
          .filter(item => item.fournisseur)
          .map(item => item.fournisseur)
      ))].filter(Boolean);

      this.suppliers = uniqueSuppliers.map(supplier => ({
        text: supplier,
        value: supplier
      }));

      // Extract unique durations
      const uniqueDurations = [...new Set(offers.flatMap(offer =>
        offer.resultat?.result
          .filter(item => item.DUREE)
          .map(item => parseInt(item.DUREE))
      ))].filter(Boolean);

      // Sort durations numerically
      uniqueDurations.sort((a, b) => a - b);

      this.durations = uniqueDurations.map(duration => ({
        text: `${duration} mois`,
        value: duration
      }));

      // Extract unique energy types
      const uniqueTypes = [...new Set(offers.flatMap(offer =>
        offer.resultat?.result
          .filter(item => item.type)
          .map(item => item.type)
      ))].filter(Boolean);

      // Sort types alphabetically
      uniqueTypes.sort();

      this.types = uniqueTypes.map(type => ({
        text: type,
        value: type
      }));


    },

    applyFilters() {
      const filters = {
        suppliers: this.selectedSupplier,
        durations: this.selectedDuration,
        types: this.selectedType,
        remunerationTypes: this.selectedRemuneration,
        budgetSort: this.budgetSortOption,
        commissionSort: this.commissionSortOption,
        startDate: this.startDate,
        endDate: this.endDate,
        greenEnergyOnly: this.greenEnergyOnly
      };

      this.$emit('filter-applied', filters);

      // Auto collapse the filter panel after applying
      this.isExpanded = false;
    },

    resetFilters() {
      this.selectedSupplier = [];
      this.selectedDuration = [];
      this.selectedType = [];
      this.selectedRemuneration = [];
      this.budgetSortOption = null;
      this.commissionSortOption = null;
      this.startDate = null;
      this.endDate = null;
      this.greenEnergyOnly = false;

      this.applyFilters();
    }
  }
};
</script>

<style scoped>
.filters-container {
  position: relative;
  z-index: 2;
}

.filter-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.filter-header {
  cursor: pointer;
  padding: 16px 20px;
  background-color: #f5f7fa;
  transition: background-color 0.2s ease;
}

.filter-header:hover {
  background-color: #eef1f6;
}

.filter-select {
  margin-bottom: 12px;
}

.sort-toggle {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-actions {
  background-color: #f9fafb;
}

.active-filters-indicator {
  background-color: #f5f7fa;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
</style>